var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComboChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2AB07771-F7FB-4313-884C-568811EBDF99") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,0.0001 C3.553,0.0001 4,0.4481 4,1.0001 L4,29.0001 C4,29.5521 3.553,30.0001 3,30.0001 L1,30.0001 C0.447,30.0001 0,29.5521 0,29.0001 L0,1.0001 C0,0.4481 0.447,0.0001 1,0.0001 L3,0.0001 Z M7.8027,9.9 C8.3557,9.9 8.8027,10.348 8.8027,10.9 L8.8027,28.9 C8.8027,29.452 8.3557,29.9 7.8027,29.9 L5.8027,29.9 C5.2507,29.9 4.8027,29.452 4.8027,28.9 L4.8027,10.9 C4.8027,10.348 5.2507,9.9 5.8027,9.9 L7.8027,9.9 Z M12.8027,19.9 C13.3557,19.9 13.8027,20.348 13.8027,20.9 L13.8027,28.9 C13.8027,29.452 13.3557,29.9 12.8027,29.9 L10.8027,29.9 C10.2507,29.9 9.8027,29.452 9.8027,28.9 L9.8027,20.9 C9.8027,20.348 10.2507,19.9 10.8027,19.9 L12.8027,19.9 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1973,0.0001 C3.7493,0.0001 4.1973,0.4481 4.1973,1.0001 L4.1973,29.0001 C4.1973,29.5521 3.7493,30.0001 3.1973,30.0001 L1.1973,30.0001 C0.6443,30.0001 0.1973,29.5521 0.1973,29.0001 L0.1973,1.0001 C0.1973,0.4481 0.6443,0.0001 1.1973,0.0001 L3.1973,0.0001 Z M8,9.9 C8.553,9.9 9,10.348 9,10.9 L9,28.9 C9,29.452 8.553,29.9 8,29.9 L6,29.9 C5.447,29.9 5,29.452 5,28.9 L5,10.9 C5,10.348 5.447,9.9 6,9.9 L8,9.9 Z M13,19.9 C13.553,19.9 14,20.348 14,20.9 L14,28.9 C14,29.452 13.553,29.9 13,29.9 L11,29.9 C10.447,29.9 10,29.452 10,28.9 L10,20.9 C10,20.348 10.447,19.9 11,19.9 L13,19.9 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-67.000000, -512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(24.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Combo-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(21.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.000000, -5.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboChart);
export default __webpack_public_path__ + "static/media/comboChart.0768b07846721449379d009cf4e938ce.svg";
export { ForwardRef as ReactComponent };